import React from 'react';
import { Trophy, Users, ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

export const AchievementsTeaser: React.FC = () => {
  return (
    <section className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 uppercase tracking-wide mb-4">
            Dostignuća i <span className="text-go2-pink">Ekipa</span>
          </h2>
          <div className="w-24 h-1 bg-go2-blue mx-auto mb-6"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          {/* Achievements Block */}
          <div className="bg-white rounded-2xl p-10 shadow-lg border border-gray-100 relative overflow-hidden group hover:shadow-xl transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-yellow-50 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110"></div>
            <div className="absolute top-6 right-6 text-yellow-200">
              <Trophy className="w-12 h-12" />
            </div>

            <div className="relative z-10">
              <div className="w-16 h-16 bg-yellow-100 rounded-2xl flex items-center justify-center text-yellow-600 mb-8 shadow-sm">
                <Trophy className="w-8 h-8" />
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4 uppercase">Dostignuća</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Otključaj dodatne nagrade za akcije kao što su dva putovanja u jednoj godini, odlazak na letovanje i zimovanje, ili organizovanje veće ekipe.
              </p>

              <Link
                to="/go2-legende/dashboard?tab=achievements"
                className="inline-flex items-center text-white bg-yellow-500 px-6 py-3 rounded-full font-bold uppercase text-sm hover:bg-yellow-600 transition-colors shadow-md"
              >
                Vidi dostignuća
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </div>
          </div>

          {/* Refer a Friend Block */}
          <div className="bg-white rounded-2xl p-10 shadow-lg border border-gray-100 relative overflow-hidden group hover:shadow-xl transition-all">
            <div className="absolute top-0 right-0 w-32 h-32 bg-go2-pink/10 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110"></div>
            <div className="absolute top-6 right-6 text-pink-200">
              <Users className="w-12 h-12" />
            </div>

            <div className="relative z-10">
              <div className="w-16 h-16 bg-pink-100 rounded-2xl flex items-center justify-center text-go2-pink mb-8 shadow-sm">
                <Users className="w-8 h-8" />
              </div>

              <h3 className="text-2xl font-bold text-gray-900 mb-4 uppercase">Preporuči prijatelja</h3>
              <p className="text-gray-600 mb-8 leading-relaxed">
                Podeli svoj lični kod. Tvoji prijatelji dobijaju bonus dobrodošlice, a ti dobijaš dodatne bodove svaki put kada putuju sa Go2.
              </p>

              <Link
                to="/go2-legende/dashboard?tab=referral"
                className="inline-flex items-center text-white bg-go2-pink px-6 py-3 rounded-full font-bold uppercase text-sm hover:bg-brand-600 transition-colors shadow-md"
              >
                Preuzmi kod
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
